//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



    
    import headerBackTitle from '@/components/header/headerBackTitle'
    import share from '@/components/share/share'
    // 猎聘分享
    import { share4App } from '@/crowd_fund/active1017/share.js'

    //测试
    import ActPoster_zgshfp_test from '../assets/images/active1017/ActPoster_zgshfp_test.png'
    import ActPoster_ele_test from '../assets/images/active1017/ActPoster_ele_test.png'
    import ActPoster_tencent_news_test from '../assets/images/active1017/ActPoster_tencent_news_test.png'
    import ActPoster_zhuanzhuan_test from '../assets/images/active1017/ActPoster_zhuanzhuan_test.png'
    import ActPoster_zhipin_test from '../assets/images/active1017/ActPoster_zhipin_test.png'
    import ActPoster_ifeng_test from '../assets/images/active1017/ActPoster_ifeng_test.png'
    import ActPoster_liepin_test from '../assets/images/active1017/ActPoster_liepin_test.png'
    import ActPoster_chinapost_test from '../assets/images/active1017/ActPoster_chinapost_test.png'
    import ActPoster_sunlands_test from '../assets/images/active1017/ActPoster_sunlands_test.png'
    //灰度
    import ActPoster_zgshfp_grey from '../assets/images/active1017/ActPoster_zgshfp_grey.png'
    import ActPoster_ele_grey from '../assets/images/active1017/ActPoster_ele_grey.png'
    import ActPoster_tencent_news_grey from '../assets/images/active1017/ActPoster_tencent_news_grey.png'
    import ActPoster_zhuanzhuan_grey from '../assets/images/active1017/ActPoster_zhuanzhuan_grey.png'
    import ActPoster_zhipin_grey from '../assets/images/active1017/ActPoster_zhipin_grey.png'
    import ActPoster_ifeng_grey from '../assets/images/active1017/ActPoster_ifeng_grey.png'
    import ActPoster_liepin_grey from '../assets/images/active1017/ActPoster_liepin_grey.png'
    import ActPoster_chinapost_grey from '../assets/images/active1017/ActPoster_chinapost_grey.png'
    import ActPoster_sunlands_grey from '../assets/images/active1017/ActPoster_sunlands_grey.png'
    //生产
    import ActPoster_zgshfp_main from '../assets/images/active1017/ActPoster_zgshfp_main.png'
    import ActPoster_ele_main from '../assets/images/active1017/ActPoster_ele_main.png'
    import ActPoster_tencent_news_main from '../assets/images/active1017/ActPoster_tencent_news_main.png'
    import ActPoster_zhuanzhuan_main from '../assets/images/active1017/ActPoster_zhuanzhuan_main.png'
    import ActPoster_zhipin_main from '../assets/images/active1017/ActPoster_zhipin_main.png'
    import ActPoster_ifeng_main from '../assets/images/active1017/ActPoster_ifeng_main.png'
    import ActPoster_liepin_main from '../assets/images/active1017/ActPoster_liepin_main.png'
    import ActPoster_chinapost_main from '../assets/images/active1017/ActPoster_chinapost_main.png'
    import ActPoster_sunlands_main from '../assets/images/active1017/ActPoster_sunlands_main.png'

    import DefaultheadImg from '../assets/images/active1017/ActPosterHeader.png'

    export default {
        components: {share, headerBackTitle},
        data () {
            function functiona (parama,paramb) {
                console.log(parama);
                console.log(paramb);
            }
            return {
                defaultImgURI: 'this.src="'+require('../assets/images/fpw_logo_small.png')+'"',
                imgUrl: 'require(../assets/images/icon_9.png)',
                shareInfo: {},
                zcnickname: decodeURIComponent(this.$route.params.zcnickname),
                zcfoundation: decodeURIComponent(this.$route.params.zcfoundation),
                bannerImgURI: require('../assets/images/certificate_train_jzcg_b.png'),
                bannerClickURI: 'https://wx.zgshfp.com.cn/mobile/index.html#/tab/home',
                isLogin: true,
                NotPay:false,
                // 1017活动
                ActPoster_if:false,  //是否展示海报
                ShareShow:false,    //显示分享按钮
                PosterPNG:'error',  //绑定海报图片
                CavasOpacity:'',    //Canvas透明度
                shareSaveImgURL:'',     //分享的图片地址，APP分享，上传图片接口返回的地址
                TxSaveImgShow:false,   //腾讯保存图片按钮弹窗控制
            }
        },
        methods: {
            CloseNotPay(){
                this.NotPay=false
            },
            difLogin(){
                if(this.$route.params.zctoken == '(null)' || this.$route.params.zctoken == undefined || this.$route.params.zctoken == '' || this.$route.params.zctoken == null || this.$route.params.zctoken == 'null'){
                    this.isLogin=false;
                }
                var ua = window.navigator.userAgent;
                // 腾讯app
                var isTxNews = ua.match(/qqnews\/([\.\d]+)/i);
                // 尚德app-企业
                var isSunland = ua.match(/sunland/i);
                // 邮政
                var isYlxd = /ulxdapp/.test(navigator.userAgent.toLowerCase())
                // 猎聘
                var isLiePinAndroid = (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) && ua.indexOf('android-tongdao-app') > -1;
                var isLiePinIos = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && ua.indexOf('ios-tongdao-app') > -1;
                var isLiePin = isLiePinAndroid || isLiePinIos;

                if ((isTxNews&&isTxNews[1]) || isSunland || isYlxd || isLiePin || /(Android)/i.test(navigator.userAgent)){
                    this.L('anlpbaFlag','2')
                }
            },
            shareFn(){
                // this.$refs.sharea.toShare()
                let self = this;
                // 猎聘
                var ua = window.navigator.userAgent;
                var isLiePinAndroid = (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) && ua.indexOf('android-tongdao-app') > -1;
                var isLiePinIos = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && ua.indexOf('ios-tongdao-app') > -1;
                var isLiePin = isLiePinAndroid || isLiePinIos;
                if (window.TencentNews && window.TencentNews.setShareArticleInfo) {
                    // 
                    console.log(self.shareInfo)
                    window.TencentNews.setShareArticleInfo(self.shareInfo.title,'',self.shareInfo.text,self.shareInfo.url,self.shareInfo.picurl);
                }else if (/sunland/i.test(navigator.userAgent) && window.JSBridge && window.JSBridge.doAction) {
                    // 尚德企业app
                    // 显示隐藏App标题栏右上角的分享按钮
                    window.JSBridge.doAction('showShareButton','{}','{}');
                    // 设置分享内容
                    let lineLink=this.appjump_url+'/pages/index/index.html#/active1017?isShare=share&ActCode='+this.$route.query.ActCode+'&channelCode='+this.$route.query.channelCode;//要分享页面的地址，即该页面地址
                    var shareInfosd = {
                      title : '1017 一起“助扶”',
                      content: '“扶”星高照 助力脱贫攻坚',
                      url : lineLink,
                      imgUrl: this.appjump_url+'/pages/index/shareIcon/actShare.jpeg'
                    };
                    window.JSBridge.doAction('setShareContent', '{}', JSON.stringify(shareInfosd));
                }else if (isLiePin) {
                    let self = this;
                    this.liepin_Share4App_URL()
                }
                else if(this.isWeixinCient()){
                    _czc.push(﻿['_trackEvent','分享按钮','微信端','分享功能',1])
                    setTimeout(function(){
                        self.showToast('','text','请点击右上角进行分享','20em','','')
                    },200)
                }else{
                    // console.log("推荐ye分享信息++++++++++++++++<br>"+this.shareInfo)
                    _czc.push(﻿['_trackEvent','分享按钮','APP端','分享功能',1])
                    setTimeout(function(){

                        var u = navigator.userAgent
                        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                        if(isiOS){
                            window.share.getShareDetailView(self.shareInfo);
                        }else{
                            window.android.getShareDetailView(self.shareInfo);
                        }


                        // window.share.getShareDetailView(self.shareInfo);
                    },200)
                }
            },
            getShareNeedInfo () {
                if(this.zcnickname=='null'){
                    this.zcnickname='社会帮扶网-匿名'
                }
                console.log("推荐ye分享信息++++++++++++++++<br>"+JSON.parse(this.G('zcPayBack_ShareInfo')))
                this.shareInfo=JSON.parse(this.G('zcPayBack_ShareInfo'))
                if(this.isWeixinCient()){
                    this.setWeixinConfig(this.shareInfo);
                }
            },
            getUserHeader(){
                if(this.isWeixinCient()){
                    return this.G('zcheadimgurl')
                }else {
                    if(this.G('zcheadimgurl')!=undefined&&this.G('zcheadimgurl')!=null&&this.G('zcheadimgurl')!='undefined'&&this.G('zcheadimgurl')!='null'&&this.G('zcheadimgurl')!='(null)'&&this.G('zcheadimgurl')!='(undefined)'&&this.G('zcheadimgurl')!=''){
                        if(this.$route.query.ActCode){
                            console.log(this.zc_userhead_act+this.G('zcheadimgurl'))
                            return this.zc_userhead_act+this.G('zcheadimgurl')
                        }else{
                            return this.zc_userhead+this.G('zcheadimgurl')
                        }
                    }else{
                        return 'error'
                    }
                }
            },
            ToCert(){
                let self = this;
                if(this.isWeixinCient()){
                    _czc.push(﻿['_trackEvent','众筹查看证书','微信端','点击查看证书',1])
                    setTimeout(function(){
                        self.$router.push('/zccertificate/'+self.$route.params.acr002+'/'+self.$route.params.donateTime+'/'+self.$route.params.projectId+'/'+self.$route.params.zcuserid+'/'+self.$route.params.zctoken+'/'+self.$route.params.zcnickname+'/'+self.$route.params.zcmoney+'/'+self.$route.params.zcfoundation);
                    }, 200)
                    
                }else{
                    _czc.push(﻿['_trackEvent','众筹查看证书','APP端','点击查看证书',1])
                    var form_dataa = new FormData();
                    form_dataa.append("payOrderId",this.$route.params.orderno)
                    form_dataa.append("txnTime","")
                    /*let data = {
                        payOrderId: this.$route.params.orderno,
                        txnTime:"",
                    }*/
                    console.log(form_dataa);
                    this.$https.post(this.BASE_URL+"cfs/v1/queryOrder",form_dataa,{headers:{'Content-Type':false}}
                    ).then(res => {
                        console.log(res);
                        if(res.data.code=="CFSPTSI0000"){
                            if(res.data.data.orderState=="SUCCESS"){
                                if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
                                    this.$router.push('/zccertificate/'+this.$route.params.acr002+'/'+this.$route.params.donateTime+'/'+this.$route.params.projectId+'/'+this.$route.params.zcuserid+'/'+this.$route.params.zctoken+'/'+this.$route.params.zcnickname+'/'+this.$route.params.zcmoney+'/'+this.$route.params.zcfoundation);
                                }else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
                                    this.$router.push('/zccertificate/'+this.$route.params.acr002+'/'+this.$route.params.donateTime+'/'+this.$route.params.projectId+'/'+this.$route.params.zcuserid+'/'+this.$route.params.zctoken+'/'+this.$route.params.zcnickname+'/'+this.$route.params.zcmoney+'/'+this.$route.params.zcfoundation);
                                }
                            }else{
                                this.NotPay=true;
                            }
                        }
                    }).catch(err=>{
                        console.log(err);
                        this.NotPay=true;
                    })
                }
            },
            getCMSBanner(){
                let dataa = {
                    pageIndex:1,
                    pageSize:1,
                    pageId:this.CMSID_CERT
                }
                this.$jsonp(this.wechat_url+'shfp/revision/zspt/columnget/getArticlePage',dataa)
                .then( res => {
                    if(res.result.status==200){
                        var re =res.result.informationInfos[0];
                        this.bannerImgURI = re.TITLE_IMAGE_URL;
                        this.bannerClickURI = re.ARTICLE_DYNIAMIC_URL;
                    }
                }).catch(function(err) {
                    console.log(err)
                })
            },
            bannerClick(){
                let self = this;
                if(this.isWeixinCient()){
                    _czc.push(﻿['_trackEvent','众筹推荐页Banner','微信端','点击查看证书',1])
                    setTimeout(function(){
                        window.location.href=self.bannerClickURI
                    }, 200);
                }else{
                    _czc.push(﻿['_trackEvent','众筹推荐页Banner','APP端','点击查看证书',1])
                    setTimeout(function(){
                        window.jumpElectricity.jumpToElectricity('1')
                    },200);
                }
            },
            drawCanvas(){
                var self = this;
                console.log('drawCanva1s()')
                var headerimg = new Image();
                headerimg.setAttribute("crossOrigin",'Anonymous');
                headerimg.src = ((self.getUserHeader()!='error'&&self.getUserHeader()!=null&&self.getUserHeader()!='null'&&self.getUserHeader()!='undefined'&&self.getUserHeader()!=undefined&&self.getUserHeader()!='') ? self.getUserHeader() :DefaultheadImg);
                console.log('headerimg.src::::<br/>'+headerimg.src)
                var bgimg=new Image();
                bgimg.setAttribute("crossOrigin",'Anonymous');
                headerimg.onload = function(){
                    console.log('1')
                    if(self.wechat_url.indexOf('fpmai')>0){
                        if(self.$route.query.channelCode=='ele'){
                            bgimg.src = ActPoster_ele_test;
                        }else if(self.$route.query.channelCode=='tencent_news'){
                            bgimg.src = ActPoster_tencent_news_test;
                        }else if(self.$route.query.channelCode=='zhuanzhuan'){
                            bgimg.src = ActPoster_zhuanzhuan_test;
                        }else if(self.$route.query.channelCode=='zhipin'){
                            bgimg.src = ActPoster_zhipin_test;
                        }else if(self.$route.query.channelCode=='ifeng'){
                            bgimg.src = ActPoster_ifeng_test;
                        }else if(self.$route.query.channelCode=='sunlands'){
                            bgimg.src = ActPoster_sunlands_test;
                        }else if (self.$route.query.channelCode=='liepin') {
                            bgimg.src = ActPoster_liepin_test;
                        }else if (self.$route.query.channelCode=='chinapost') {
                            bgimg.src = ActPoster_chinapost_test;
                        }else{
                            bgimg.src = ActPoster_zgshfp_test;
                        }
                    }else if (self.wechat_url.indexOf('shfp1017')>0) {
                        if(self.$route.query.channelCode=='ele'){
                            bgimg.src = ActPoster_ele_grey;
                        }else if(self.$route.query.channelCode=='tencent_news'){
                            bgimg.src = ActPoster_tencent_news_grey;
                        }else if(self.$route.query.channelCode=='zhuanzhuan'){
                            bgimg.src = ActPoster_zhuanzhuan_grey;
                        }else if(self.$route.query.channelCode=='zhipin'){
                            bgimg.src = ActPoster_zhipin_grey;
                        }else if(self.$route.query.channelCode=='ifeng'){
                            bgimg.src = ActPoster_ifeng_grey;
                        }else if(self.$route.query.channelCode=='sunlands'){
                            bgimg.src = ActPoster_sunlands_grey;
                        }else if (self.$route.query.channelCode=='liepin') {
                            bgimg.src = ActPoster_liepin_grey;
                        }else if (self.$route.query.channelCode=='chinapost') {
                            bgimg.src = ActPoster_chinapost_grey;
                        }else{
                            bgimg.src = ActPoster_zgshfp_grey;
                        }
                    }else if (self.wechat_url.indexOf('zgshfp')>0) {
                        if(self.$route.query.channelCode=='ele'){
                            bgimg.src = ActPoster_ele_main;
                        }else if(self.$route.query.channelCode=='tencent_news'){
                            bgimg.src = ActPoster_tencent_news_main;
                        }else if(self.$route.query.channelCode=='zhuanzhuan'){
                            bgimg.src = ActPoster_zhuanzhuan_main;
                        }else if(self.$route.query.channelCode=='zhipin'){
                            bgimg.src = ActPoster_zhipin_main;
                        }else if(self.$route.query.channelCode=='ifeng'){
                            bgimg.src = ActPoster_ifeng_main;
                        }else if(self.$route.query.channelCode=='sunlands'){
                            bgimg.src = ActPoster_sunlands_main;
                        }else if (self.$route.query.channelCode=='liepin') {
                            bgimg.src = ActPoster_liepin_main;
                        }else if (self.$route.query.channelCode=='chinapost') {
                            bgimg.src = ActPoster_chinapost_main;
                        }else{
                            bgimg.src = ActPoster_zgshfp_main;
                        }
                    }
                }    
                var posterCanvas = document.getElementById('ActPosters');
                var poCv = posterCanvas.getContext('2d');
                var getPixelRatio = function (context) {
                    var backingStore = context.backingStorePixelRatio ||
                            context.webkitBackingStorePixelRatio ||
                            context.mozBackingStorePixelRatio ||
                            context.msBackingStorePixelRatio ||
                            context.oBackingStorePixelRatio ||
                            context.backingStorePixelRatio || 1;
                    return (window.devicePixelRatio || 1) / backingStore;
                };
                var ratio = getPixelRatio(posterCanvas);
                posterCanvas.width = posterCanvas.width * ratio;
                posterCanvas.height = posterCanvas.height * ratio;
                console.log('开始绘制')
                bgimg.onload=function(){
                    console.log('2')
                    poCv.drawImage(bgimg,0 * ratio,0 * ratio,300 * ratio,270 * ratio);
                    poCv.arc(18 * ratio + 40 * ratio/2,170 * ratio + 40 * ratio/2,40 * ratio/2,0, 2 * Math.PI);
                    poCv.clip();
                    poCv.drawImage(headerimg,18 * ratio,170 * ratio,40 * ratio,40 * ratio);
                    posterCanvas.style.width = posterCanvas.width / ratio + 'px';
                    posterCanvas.style.height = posterCanvas.height / ratio + 'px';
                    poCv.scale(ratio, ratio);
                    self.PosterPNG = posterCanvas.toDataURL("image/png");
                    console.log('转换完成')
                    self.ShareShow = true;
                    self.CavasOpacity = {"display":'none'};
                    // }
                }
            },
            liepin_Share4App_URL(){
                console.log('liepin_Share4App_URL')
                let self = this;
                share4App({
                    type: [17, 16],
                    showshare: true, // 是否展示分享按钮
                    mediaType: 0,//链接
                    title: '中国社会帮扶网',
                    shareTitle: '1017 一起“助扶”',
                    shareUrl: self.appjump_url+'/pages/index/index.html#/active1017?isShare=share&ActCode='+self.$route.query.ActCode+'&channelCode='+self.$route.query.channelCode,
                    desc: '“扶”星高照 助力脱贫攻坚',
                    thumburl: self.appjump_url+'/pages/index/shareIcon/actShare.jpeg',
                    imgUrl: self.appjump_url+'/pages/index/shareIcon/actShare.jpeg', 
                })
                share4App({
                    type: [53],
                })
            },
            ShareAct(){  
                let self = this;
                var ua = window.navigator.userAgent;
                // 尚德app-企业
                var isSunland = ua.match(/sunland/i);
                // 猎聘
                var isLiePinAndroid = (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) && ua.indexOf('android-tongdao-app') > -1;
                var isLiePinIos = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && ua.indexOf('ios-tongdao-app') > -1;
                var isLiePin = isLiePinAndroid || isLiePinIos;
                console.log('分享分享分享————————————————shareAct')
                if (window.TencentNews && window.TencentNews.showBigImageShareMenu) {
                    console.log('腾讯————————————————shareAct')
                    var jsonObject = {
                         "url":this.appjump_url+"/pages/index/static/img/ActPoster_TecentAppShare.png",
                         "onCallback": function (res) {
                            consoles.log(JSON.stringify(res))
                         }
                    };
                    window.TencentNews.showBigImageShareMenu(jsonObject);
                }else if(isSunland){
                    console.log('尚德————————————————shareAct')
                    let lineLink=this.appjump_url+'/pages/index/index.html#/active1017?isShare=share&ActCode='+this.$route.query.ActCode+'&channelCode='+this.$route.query.channelCode;//要分享页面的地址，即该页面地址
                    let title = '1017 一起“助扶”';
                    let desc = '“扶”星高照 助力脱贫攻坚';
                    let link = lineLink;
                    let imgUrl = this.appjump_url+'/pages/index/shareIcon/actShare.jpeg'

                    JSBridge.doAction("setShareContent",JSON.stringify({}),JSON.stringify({
                        title:title,
                        content:desc,
                        url:lineLink,
                        imgUrl:imgUrl,
                    }));

                    JSBridge.doAction('actionShare', JSON.stringify({}), JSON.stringify({
                        title  : title,
                        content: desc,
                        url    : lineLink,
                        imgUrl : imgUrl,
                    }));
                }else if (/ulxdapp/.test(navigator.userAgent.toLowerCase())) {
                    let lineLink=this.appjump_url+'/pages/index/index.html#/active1017?isShare=share&ActCode='+this.$route.query.ActCode+'&channelCode='+this.$route.query.channelCode;//要分享页面的地址，即该页面地址
                    let title = '1017 一起“助扶”';
                    let desc = '“扶”星高照 助力脱贫攻坚';
                    let link = lineLink;
                    let imgUrl = this.appjump_url+'/pages/index/shareIcon/actShare.jpeg'
                    window.location.href = 'uleMobile://uleShare_'+ encodeURIComponent(title) +'##'+ encodeURIComponent(desc) +'##'+ imgUrl +'##'+ link;
                }else if (isLiePin) {
                    this.liepin_Share4App_URL()
                    console.log('猎聘app')
                }
                else if(this.isWeixinCient()){
                    console.log('微信————————————————shareAct')
                    let lineLink=this.appjump_url+'/pages/index/index.html#/active1017?isShare=share&ActCode='+this.$route.query.ActCode+'&channelCode='+this.$route.query.channelCode;//要分享页面的地址，即该页面地址
                    this.shareInfo = {
                      title : '1017 一起“助扶”',
                      desc: '“扶”星高照 助力脱贫攻坚',
                      link : lineLink,
                      imgUrl: this.appjump_url+'/pages/index/shareIcon/actShare.jpeg'
                    };
                    // this.L('zcPayBack_ShareInfo',JSON.stringify(this.shareInfo));
                    this.setWeixinConfig(this.shareInfo);
                    this.shareFn();
                }else{
                    console.log('APP————————————————shareAct')
                    if(!self.shareSaveImgURL){
                        console.log('开始走保存图片到服务器的接口')
                        this.$https.post(this.BASE_URL+"cfs/file/resImgUpload",this.qs.stringify({base64String:this.PosterPNG}),{
                            headers: { 'content-type': 'application/x-www-form-urlencoded' }
                        }).then(res => {
                            console.log(res)
                            if(res.data.code=="CFSI0000"){
                                self.shareSaveImgURL = res.data.data;
                                var shareImgObj = '{"title":"","url":"'+self.shareSaveImgURL+'"}'
                                console.log('shareImgObj：inAJAX：：<br/>'+shareImgObj)
                                window.appShare.shareImage(shareImgObj)
                            }
                        })
                    }else{
                        console.log('已经走完保存图片到服务器的接口，直接使用存储好的URL')
                        let shareImgObj = '{"title":"","url":"'+self.shareSaveImgURL+'"}'
                        console.log('shareImgObj：：：<br/>'+shareImgObj)
                        window.appShare.shareImage(shareImgObj)
                    }
                }
            },
            TxNewSavetoLocal(){
                // 猎聘
                var ua = window.navigator.userAgent;
                var isLiePinAndroid = (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) && ua.indexOf('android-tongdao-app') > -1;
                var isLiePinIos = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && ua.indexOf('ios-tongdao-app') > -1;
                var isLiePin = isLiePinAndroid || isLiePinIos;
                if (window.TencentNews && window.TencentNews.saveImageToLocal) {
                    this.TxSaveImgShow=true
                }else if(/sunland/i.test(ua)){
                    // 尚德企业app&&安卓内
                    console.log('TxNewSavetoLocal()尚德企业app')
                    if(/(Android)/i.test(ua)){
                        this.TxSaveImgShow=true
                    }
                }else if (/ulxdapp/.test(ua.toLowerCase())) {
                    // 中国邮政
                    console.log('中国邮政')
                }else if (isLiePin) {
                    // 猎聘
                    console.log('猎聘')
                }else if(this.isWeixinCient()){
                    console.log('TxNewSavetoLocal()微信——— SavetoLocal')
                }else{
                    console.log('TxNewSavetoLocal()APP——— SavetoLocal')
                    // 保存到本地
                    if(!self.shareSaveImgURL){
                        console.log('开始走保存图片到服务器的接口::APP存储本地')
                        this.$https.post(this.BASE_URL+"cfs/file/resImgUpload",this.qs.stringify({base64String:this.PosterPNG}),{
                            headers: { 'content-type': 'application/x-www-form-urlencoded' }
                        }).then(res => {
                            console.log(res)
                            if(res.data.code=="CFSI0000"){
                                self.shareSaveImgURL = res.data.data;
                                this.TxSaveImgShow=true
                            }
                        })
                    }else{
                        console.log('已经保存图片到服务器，直接使用存储好的URL::APP存储本地')
                        this.TxSaveImgShow=true
                        
                    }
                }
            },
            TxSaveImg(){
                 if (window.TencentNews && window.TencentNews.saveImageToLocal) {
                    window.TencentNews.saveImageToLocal(this.appjump_url+"/pages/index/static/img/ActPoster_TecentAppShare.png",'png');
                }else if(/sunland/i.test(navigator.userAgent)){
                    // 尚德企业app&&安卓内
                    console.log('保存开始')
                    let action = "savePhoto";
                    let callback = {'endDownload':'functiona(0,1)'};
                    let data = {
                        "urlDownload": this.appjump_url+"/pages/index/static/img/ActPoster_SunlandsAppShare.png",
                        "fileName":this.appjump_url+"/pages/index/static/img/ActPoster_SunlandsAppShare.png"
                    };
                    window.JSBridge.doAction(action,JSON.stringify(callback),JSON.stringify(data));
                    console.log('保存完成');
                }else if(this.isWeixinCient()){
                    console.log('TxSaveImg()::微信————— SavetoLocal')
                }else{
                    console.log('TxSaveImg()::APP————— SavetoLocal')
                    window.saveImg.onSave(self.shareSaveImgURL)
                }
            },
            TxSaveCancel(){
                this.TxSaveImgShow=false
            },
            CloseAct(){
                this.ActPoster_if=false;
            }
        },
        mounted () {
            console.log(window.location.href,'这是证书推荐页地址')
            this.getShareNeedInfo();
            if(this.isWeixinCient()){
                this.getCMSBanner();
            }else{
                this.difLogin();
            }
            if(this.$route.query.ActCode){
                this.ActPoster_if=true;
                var self = this
                console.log('self')
                setTimeout(function(){
                    console.log('self-mounted')
                    if(self.$route.query.channelCode){
                        var ua = window.navigator.userAgent;
                        // 腾讯app
                        var isTxNews = ua.match(/qqnews\/([\.\d]+)/i);
                        // 中国邮政 邮乐购
                        var isYlxd = /ulxdapp/.test(navigator.userAgent.toLowerCase());
                        // 尚德app-企业
                        var isSunland = ua.match(/sunland/i);
                        // 猎聘
                        var isLiePinAndroid = (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) && ua.indexOf('android-tongdao-app') > -1;
                        var isLiePinIos = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && ua.indexOf('ios-tongdao-app') > -1;
                        var isLiePin = isLiePinAndroid || isLiePinIos;

                        if(isTxNews&&isTxNews[1]){
                            self.CavasOpacity = {"display":'none'};
                            self.PosterPNG = self.appjump_url+"/pages/index/static/img/ActPoster_TecentAppShare.png";
                            self.ShareShow = true;
                        }else if(isSunland&&isSunland[0]){
                            self.CavasOpacity = {"display":'none'};
                            self.PosterPNG = self.appjump_url+"/pages/index/static/img/ActPoster_SunlandsAppShare.png";
                            self.ShareShow = true;
                        }else if(isYlxd){
                            self.CavasOpacity = {"display":'none'};
                            self.PosterPNG = self.appjump_url+"/pages/index/static/img/ActPoster_chinaPostAppShare.png";
                            self.ShareShow = true;
                        }else if(isLiePin){
                            self.CavasOpacity = {"display":'none'};
                            self.PosterPNG = self.appjump_url+"/pages/index/static/img/ActPoster_liepinAppShare.png";
                            self.ShareShow = true;
                        }else{
                            self.drawCanvas()
                        }
                    }
                },100)
            }
        },
        computed: {
            nickName () {
                // return this.$store.state.user.nick_name
                // if(this.G('nick_name')) {
                //     return this.G('nick_name');
                // }else {
                //     return this.$store.state.user.nick_name;
                // }
            }
        },
        created() {
            var ua = window.navigator.userAgent;
            // 腾讯app
            var isTxNews = ua.match(/qqnews\/([\.\d]+)/i);
            // 尚德app-企业
            var isSunland = ua.match(/sunland/i);
            // var isTxNews = window.navigator.userAgent.match(/qqnews\/([\.\d]+)/i);
            if(isTxNews&&isTxNews[1]){
                let TXscripts = document.createElement('script');
                TXscripts.type = 'text/javascript';
                TXscripts.src = 'https://mat1.gtimg.com/www/js/newsapp/jsapi/news.js?_tsid=1';
                document.getElementsByTagName('head')[0].appendChild(TXscripts)
            }else if (isSunland&&isSunland[0]) {
                console.log('这是尚德APP')
            }
            this.zcnickname = this.$route.params.zcnickname;
            console.log(this.zcnickname);
        }
    } 



// WEBPACK FOOTER //
// ./src/crowd_fund/certificate_train.vue